import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color';

const { mlbGrey2 } = COLORS;

export const PlayerStatsContentWrapper = styled.span`
    display: inline-block;
`;

export const PlayerStatsSeparator = styled.span`
    margin: 0 5px;
    color: ${mlbGrey2};
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    height: 15px;
`;
